module.exports = __webpack_public_path__ + "static/media/4857-2506-3103 v1 Order  - 16-MAY-2024 (002).f9d67f42.pdf";